import { IMAGES } from "@/content";

const Fig = ({ src, alt, caption, ratio }) => (
  <figure className={`reveal relative ${ratio} bg-imagebg overflow-hidden`}>
    <img src={src} alt={alt} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
    <figcaption className="lb absolute bottom-4 start-4 bg-paper/90 px-2 py-1 text-caption">{caption}</figcaption>
  </figure>
);

export const Credentials = ({ t }) => (
  <section id="credentials" className="py-24 md:py-32" data-testid="credentials-section">
    <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-[1.2fr_.8fr] gap-12 items-start">
      <div className="min-w-0">
        <h2 className="dd reveal">{t.credTitle}</h2>
        <ul className="mt-12 space-y-6 text-[17px] leading-[1.6]" data-testid="credentials-list">
          {t.credentials.map((c) => (
            <li key={c} className="reveal border-s-2 border-brass ps-6">{c}</li>
          ))}
        </ul>
      </div>
      <div className="grid gap-6">
        <Fig src={IMAGES.speaking} alt="Speaker at a professional conference" caption={t.speakingCaption} ratio="aspect-[4/3]" />
        <Fig src={IMAGES.cities} alt="City skyline at dusk" caption={t.citiesCaption} ratio="aspect-[16/9]" />
      </div>
    </div>
  </section>
);
